module.exports = __webpack_public_path__ + "img/charity_3.1f82142f.png";